import React from 'react';
import './Optisewer.scss';
//#region COMPONENTS
import Auth from './custom/Auth/Auth';
import Site from './custom/Site/Site';
import SplashScreen from './custom/SplashScreen/SplashScreen';
//#endregion
//MODELS
import { ISharedConfig } from '@shared/library';
//CONTEXTS
export const CntxConfig = React.createContext<ISharedConfig | undefined>(undefined);

const Optisewer = () => {
    const [conf, setConf] = React.useState<ISharedConfig | undefined>({ session: { support: false } });

    return (
        <CntxConfig.Provider value={{ ...conf, set: setConf }} >
            {conf?.session && !conf.session.userData ? <SplashScreen />//check if logged in
                : conf?.session && conf.session.userData ? <Site />//logged in
                    : <Auth />//logged out
            }
        </CntxConfig.Provider>
    );
};
export default Optisewer;